import { UseCaseTemplate } from "@/components/institutional/UseCaseTemplate";

const AdvisingWorkflows = () => (
  <UseCaseTemplate
    seoTitle="Advising Workflows — Use Case"
    seoDescription="Caseload triage with explainable behavioral context. CSW helps advisors prioritize outreach using engagement signals — supporting, never replacing, their professional judgment."
    canonicalUrl="/use-cases/advising-workflows/"
    eyebrow="Use case · Advising workflows"
    h1={<>Caseload triage that respects how advisors actually work.</>}
    intro={<>Advisors and success coaches don't need another inbox. They need behavioral context that helps
      them prioritize their next conversations and walk into those conversations prepared.</>}
    challenge={<>
      Most advising tools default to grade-based proxies or click-count heuristics to surface
      "at-risk" students. Advisors know this is incomplete — and often unfair. They want
      behavioral context that's specific, explainable, and obviously meant to inform their
      judgment rather than override it.
    </>}
    approach={[
      { title: "Triage view sized for real caseloads", description: "Advisors see a short, prioritized list with behavioral evidence — not a 400-student spreadsheet." },
      { title: "Explainable signal cards per student", description: "Each surfaced student includes the specific behavioral evidence behind the indicator: cadence shift, focus drift, participation change." },
      { title: "Contextual notes and outreach support", description: "Capture context across conversations so signals get richer over time, and outcomes feed back into the loop." },
    ]}
    outcome={<>
      Advisors open CSW first thing and see five to ten students whose behavioral patterns have
      shifted in the last two weeks, with the evidence behind each indicator. They decide who to
      reach out to, in what order, and with what context — and log the outcomes. The platform
      respects that the conversation belongs to the advisor.
    </>}
    trustNote="CSW supports advisor decision-making. It is not a substitute for advisor expertise, training, or professional judgment, and no signal is intended as a clinical or psychological evaluation."
    relatedAudiences={[
      { href: "/for/student-success-teams/", label: "CSW for Student Success Teams" },
      { href: "/for/universities/", label: "CSW for Universities" },
      { href: "/for/colleges/", label: "CSW for Colleges" },
    ]}
    relatedPlatform={{ href: "/platform/advisor-workflows/", label: "Platform: Advisor workflows" }}
    relatedUseCases={[
      { href: "/use-cases/early-warning/", title: "Early-warning signals" },
      { href: "/use-cases/retention/", title: "Retention support" },
      { href: "/use-cases/at-risk-cohorts/", title: "At-risk cohorts" },
    ]}
  />
);
export default AdvisingWorkflows;
